export const COLORS_PRESETS: Array<string> = [
	'#FF0000', '#FF9900', '#FFFF00', '#00FF00', '#4A86E8', '#0000FF', '#FF00FF',
	'#E06666', '#F6B26B', '#FFD966', '#93C47D', '#6FA8DC', '#3D85C6', '#C27BA0',
	'#EA9999', '#F9CB9C', '#FFE599', '#B6D7A8', '#A4C2F4', '#9FC5E8', '#D5A6BD',
	'#F4CCCC', '#FCE5CD', '#FFF2CC', '#D9EAD3', '#C9DAF8', '#CFE2F3', '#EAD1DC'
];